/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Notifications from './Notifications/index'
import React from 'react'
import TysiaCalendar from 'DesignSystem/TysiaCalendarBlocks/TysiaCalendar/react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/Appointment/Content/Content"
  
}) {
let selectedSlotMonthValueData = fromData.useDataValue({ viewPath,
context: 'selected_slot',
path: 'month',
})
let appointmentWidgetRequestScheduleSlotsValueData = fromData.useDataValue({ viewPath,
context: 'appointment_widget_request_schedule_slots',
})
let selectedSlotValueData = fromData.useDataValue({ viewPath,
context: 'selected_slot',
})
let onClickNextMonth = fromHelpers.useOnClickNextMonth({
  children,
  viewPath
  
})
let onClickPrevMonth = fromHelpers.useOnClickPrevMonth({
  children,
  viewPath
  
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let onClickNextMonth1 = fromHelpers.useOnClickNextMonth({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaCalendar
  viewPath={`${viewPath}/TysiaCalendar`}
 useRaw={true}
 data="selected_slot.month"
 month={selectedSlotMonthValueData}
 data="appointment_widget_request_schedule_slots"
 monthSlots={appointmentWidgetRequestScheduleSlotsValueData}
 onClickNextMonth={onClickNextMonth}
 onClickPrevMonth={onClickPrevMonth}
 data="selected_slot"
 value={selectedSlotValueData}
 onChange={onChange}
/>
<Notifications
  viewPath={`${viewPath}/Notifications`}
 onClickNextMonth={onClickNextMonth1}
/>
</div>
{children}
</React.Fragment>)
}